import React from "react";

const getPageItems = (page, totalPages, maxVisible) => {
  const pages = [];

  if (totalPages <= maxVisible) {
    for (let i = 1; i <= totalPages; i++) pages.push(i);
    return pages;
  }

  if (maxVisible < 7) {
    let start = Math.max(1, page - Math.floor(maxVisible / 2));
    let end = Math.min(totalPages, start + maxVisible - 1);

    if (end - start + 1 < maxVisible) {
      start = Math.max(1, end - maxVisible + 1);
    }

    for (let i = start; i <= end; i++) pages.push(i);
    return pages;
  }

  if (page <= 4) {
    pages.push(1, 2, 3, 4, "...", totalPages);
  } else if (page >= totalPages - 3) {
    pages.push(1, "...", totalPages - 3, totalPages - 2, totalPages - 1, totalPages);
  } else {
    pages.push(1, "...", page - 1, page, page + 1, "...", totalPages);
  }

  return pages;
};

const PaginationControls = ({ page, totalPages, onPageChange, maxVisible = 7 }) => {
  const items = getPageItems(page, totalPages, maxVisible);

  return (
    <div className="pagination-controls">
      <button
        className="arrow-button"
        onClick={() => onPageChange(Math.max(1, page - 1))}
        disabled={page === 1}
      >
        ←
      </button>

      {items.map((item, idx) =>
        item === "..." ? (
          <span key={`ell-${idx}`} className="ellipsis">
            …
          </span>
        ) : (
          <button
            key={item}
            className={`page-button${item === page ? " focus-button" : ""}`}
            onClick={() => onPageChange(item)}
            disabled={item === page}
          >
            {item}
          </button>
        ),
      )}

      <button
        className="arrow-button"
        onClick={() => onPageChange(Math.min(totalPages, page + 1))}
        disabled={page === totalPages}
      >
        →
      </button>
    </div>
  );
};

export default PaginationControls;
